import { ADMIN_URL } from '../../Admin/constants/constants';

const routes = [
  { name: 'Cash Flows', link: `/${ADMIN_URL}/reporting/cash-flows/` },
  { name: 'Income Statement', link: `/${ADMIN_URL}/reporting/income-statement/` },
];

export { routes };
